import React, { useState } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router';
import { Menu as AntMenu } from 'antd'
import { Text, IconBadge, FlexContainer, Drawer, Logo, AppIcon } from '../../common'
import SiderContent from '../../sections/Layouts/SidebarContent'
import { device } from '../../../utils/breakpoints'
import GetPendingPickingCount from '../../graphql/getPendingPickingCount'

const HeaderWrapper = styled(FlexContainer)`
  display: flex;
  padding: 0px 10px;
  background-color: #333333;
  color: white;
  height: 55px;

  @media ${device.tablet} {
    display: none;
  }

`

const onLogout = () => (null)

const CircleWrapper = styled.div`
  display: inline-block;
  margin-right: 10px;
  background: #333333;
  height: 30px;
  border-radius: 17.5px;
  width: 30px;
  text-align: center;
  color: white;
  font-size: .9rem;
`

const BottomMenu = () => (
  <AntMenu mode='inline'>
    <AntMenu.Item key='bottom-menu-account' onClick={() => (null)}>
      <CircleWrapper>
        <FlexContainer align='center' justify='center' style={{ height: '100%' }}>
          <span className='icon-ic-account' />
        </FlexContainer>
      </CircleWrapper>
      <Text text='sidebar.navigation.account' />
    </AntMenu.Item>
    <AntMenu.Item key='bottom-menu-logout' onClick={onLogout}>
      <CircleWrapper>
        <FlexContainer align='center' justify='center' style={{ height: '100%' }}>
          <span className='icon-ic-logout' />
        </FlexContainer>
      </CircleWrapper>
      <Text text='sidebar.navigation.exit' />
    </AntMenu.Item>
  </AntMenu>
)

const HeaderTitle = ({ onClick }) => (
  <FlexContainer style={{ height: '40px', padding: '10px 25px' }} align='center' onClick={onClick}>
    <span className='icon-ic-cross' style={{ color: 'white' }} />
    <Logo style={{ margin: '0 auto' }} white />
  </FlexContainer>
);

const Header = ({ onClick, history }) => (
    <HeaderWrapper flex={1} justify='center' align='center' >
        <FlexContainer flex={1} onClick={onClick}>
            <AppIcon name='ic-todos' fill='white' size={20} />
        </FlexContainer>
        <FlexContainer flex={2} justify='center' align='center'>
            <Logo white />
        </FlexContainer>
        <FlexContainer flex={1} justify='flex-end' align='center' style={{ marginRight: '8px' }}>
            <GetPendingPickingCount>
                {({ count }) => <IconBadge name='pie-chart' count={count} size={24} badgeY={-2} badgeX={11} onClick={() => history.push('/dashboard-ja')} /> }
            </GetPendingPickingCount>
        </FlexContainer>
    </HeaderWrapper>
);

const HeaderMenuDrawer = ({ visible, onClick }) => {
  return (
    <Drawer
      title={null}
      placement='left'
      width='100%'
      visible={visible}
      onClose={onClick}
      bodyStyle={{ padding: 0, height: '100%', background: '#333333', width: '100%', display: 'flex' }}
    >
      <FlexContainer direction='column' flex={1}>
        <HeaderTitle onClick={onClick} />
        <FlexContainer flex='1'style={{ height: '100%', width: '100%' }}>
          <SiderContent onClickMenuItemCallback={onClick} />
        </FlexContainer>
        <FlexContainer direction='column' style={{ position: 'absolute', bottom: 0, width: '100%', background: 'white' }}>
          <BottomMenu />
        </FlexContainer>
      </FlexContainer>
    </Drawer>
  )
}

const HeaderComponent = (props) => {
    const [visible, toggleVisible] = useState(false)
    return (
        <>
            <Header onClick={() => toggleVisible(!visible)} history={props.history} />
            <HeaderMenuDrawer visible={visible} onClick={() => toggleVisible(!visible)} />
        </>
    )
};

export default withRouter(HeaderComponent);
